/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_ConsentInputs */

const en_directory_ai_tools_studio_consent = /** @type {(inputs: Directory_Ai_Tools_Studio_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By generating, you confirm everyone in the photos agreed to be in the video.`)
};

const zh_directory_ai_tools_studio_consent = /** @type {(inputs: Directory_Ai_Tools_Studio_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击生成，即表示照片中的每个人都同意出现在视频里。`)
};

/**
* | output |
* | --- |
* | "By generating, you confirm everyone in the photos agreed to be in the video." |
*
* @param {Directory_Ai_Tools_Studio_ConsentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_consent = /** @type {((inputs?: Directory_Ai_Tools_Studio_ConsentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_ConsentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_consent(inputs)
	return zh_directory_ai_tools_studio_consent(inputs)
});
export { directory_ai_tools_studio_consent as "directory.ai_tools.studio.consent" }